<template>
  <div class="wrapper">
    <button class="destCard" v-on="$listeners" :class="{loading: isLoading}" :id="id">
      <transition name="fade-in">
        <div v-if="!isLoading">
          <img :src="img" :alt="city" />
          <div class="content city">
            <div class="label mb-xs">{{ location }}</div>
            <div class="cityName">{{ city }}</div>
            <div class="tags">
              <div v-for="tag in availableTags" :key="tag.id" :class="{checkmark: tag.isBoolean}" class="tag">
                <span v-if="tag.value && !tag.isBoolean" class="tag-counter">{{ tag.value }}</span>
                {{ tag.name }}
              </div>
              <div v-if="restOfTheTags.length" class="tag opacity">{{ restOfTheTags.length }} more...</div>
            </div>
          </div>
          <div class="content onHover">
            <b>See More</b>
          </div>
        </div>
      </transition>
    </button>

    <Progress
      v-if="selectedTags.length && !isLoading"
      :progress="progress"
      :full="selectedTags.length === tags.length"
    />
    <div v-if="isSelected" class="selected" />
  </div>
</template>

<script>
import Vue from 'vue';
import Progress from './progress.vue';

export default Vue.extend({
  name: 'DestinationCard',
  props: {
    id: String,
    img: String,
    location: String,
    city: String,
    tags: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Progress,
  },
  computed: {
    availableTags() {
      return (this.tags || []).slice(0, 4);
    },
    restOfTheTags() {
      return (this.tags || []).slice(4);
    },
    progress() {
      return (this.tags.length / this.selectedTags.length) * 100;
    },
  },
});
</script>

<style scoped lang="scss">
.wrapper {
  position: relative;
}
.destCard.loading {
  position: relative;
  background-color: var(--dest-card-loading-color, #f1f1f1);
  overflow: hidden;
  border-radius: var(--card-br, 20px);
  box-shadow: none;
}
.destCard {
  position: relative;
  border-radius: var(--card-br-large);
  background-color: #f7f7f7;
  color: #fff;
  width: 100%;
  height: 0px;
  padding-top: 100%;
  padding-left: 0;
  position: relative;
  display: block;
  border: none;
  appearance: none;
  text-align: left;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  overflow: hidden;
}
.destCard:hover {
  cursor: pointer;
}
.destCard img {
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
}
.destCard:not(.loading)::before {
  content: '';
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
}
.destCard:hover::before {
  background-color: rgba(7, 29, 59, 0.4);
  height: 100%;
  z-index: 1;
}
.destCard .content {
  width: 100%;
  padding: 17px 25px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  transition: 0.3s ease transform, 0.3s ease opacity;
}

.onHover {
  background-color: var(--primary-color);
  text-align: center;
}

.destCard .content.onHover {
  opacity: 0;
  transform: translateY(10px);
}
.destCard:hover .content.city {
  transform: translateY(-40px);
}
.destCard:hover .content.onHover {
  opacity: 1;
  transform: translateY(0);
}
.destCard .content .label {
  font-size: 12px;
  opacity: 0.8;
}
.destCard:hover .content.city .label {
  opacity: 0;
}
.destCard .content .label.lg {
  font-size: 14px;
  opacity: 1;
}
.destCard .content .cityName {
  font-weight: 700;
  font-size: 32px;
  line-height: 0.9em;
}

.tag {
  background-color: transparent;
  border: 1px solid #fff;
  color: #fff;
  margin: 2px;
  border-radius: var(--card-br);
  font-size: 10px !important;
  padding: 5px 10px 3px;
  display: inline-block;
  position: relative;
}

.opacity {
  opacity: 0.5;
}
.destCard .tags {
  margin-top: 10px;
}

.destCard .tags > .checkmark {
  padding-left: 20px;
  position: relative;
}

.checkmark:before {
  content: '\2714';
  position: absolute;
  top: 3px;
  left: 5px;
  width: 1em;
  height: 1em;
  display: inline-block;
}

.tag {
  text-transform: capitalize;
  max-width: calc(50% - 2px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag-counter {
  font-weight: bold;
}

.match {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.4);
}

.selected::after {
  content: '';
  width: 10px;
  height: 10px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  position: absolute;
  left: 50%;
  bottom: -25px;
  transform: rotate(-45deg);
  background: #f7f7f7;
}
</style>
